import React, { Suspense } from 'react';

import CalendarLoadingState from './CalendarLoadingState';
import { CalendarViews, EventActions } from './utility/enums';

const Calendar = React.lazy(() => import(/* webpackChunkName: "Calendar" */ './Calendar'));

const DatastoreEventProvider = React.lazy(() => import(/* webpackChunkName: "Calendar" */ './data/DatastoreEventProvider'));

export default class CalendarLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <Calendar {...this.config} />;
        const dataProvider = this._getDataProvider(component);

        return <Suspense fallback={<CalendarLoadingState {...this.config} />}>{dataProvider}</Suspense>;
    }

    _parseConfiguration(config) {
        let defaultView = CalendarViews.Day;

        if (config.defaultView === 'Schedule') {
            defaultView = CalendarViews.Schedule;
        } else if (config.defaultView === 'Week') {
            defaultView = CalendarViews.Week;
        } else if (config.defaultView === 'Month') {
            defaultView = CalendarViews.Month;
        }

        let eventAction = EventActions.OpenInModal;

        if (config.eventAction === 'link') {
            eventAction = EventActions.OpenAsLink;
        } else if (config.eventAction === 'page') {
            eventAction = EventActions.OpenInNewPage;
        }

        return {
            ...config,
            defaultView,
            eventAction,
        };
    }

    _getDataProvider(component) {
        const { datasource, datasourceUrl, datasourceJWT } = this.config;

        if (datasource === 'datastore') {
            const datastore = new Datastore({
                serviceURL: datasourceUrl,
                jwtURL: datasourceJWT,
            });

            return <DatastoreEventProvider datastore={datastore}>{component}</DatastoreEventProvider>;
        }

        return component;
    }
}
